import React, { useState } from 'react';
import { Collapse, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import styles from './ModuleCard.module.css';
import accents from './accents.module.css';

/**
 * Casca comum dos cards de módulo (tela de atendimento e aba Saúde do paciente):
 * cabeçalho com ícone em quadrado colorido (`accent`: blue, pink, green, amber,
 * purple ou teal), título, descrição e ações à direita; corpo separado por uma
 * linha; opcionalmente recolhível pelo cabeçalho.
 *
 * O corpo é desmontado quando recolhido, então popups e elementos que precisam
 * continuar montados ficam fora do card (irmãos em um fragment).
 */
const ModuleCard = ({
  title,
  icon,
  description,
  actions,
  accent = 'blue',
  collapsible = false,
  defaultExpanded = true,
  className = '',
  children,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const toggle = () => setExpanded((value) => !value);

  // Sem conteúdo, o card é só o cabeçalho (sem a linha do corpo)
  const body = children ? <div className={styles.body}>{children}</div> : null;

  return (
    <section className={`${styles.card} ${accents[accent] || accents.blue} ${className}`.trim()}>
      <div
        className={`${styles.header} ${collapsible ? styles.headerCollapsible : ''}`}
        onClick={collapsible ? toggle : undefined}
      >
        <div className={styles.title}>
          {icon && <div className={styles.iconBox}>{icon}</div>}
          <div className={styles.texts}>
            <h2>{title}</h2>
            {description && <p>{description}</p>}
          </div>
        </div>

        {(actions || collapsible) && (
          <div className={styles.actions} onClick={(e) => e.stopPropagation()}>
            {actions}
            {collapsible && (
              <IconButton
                size="small"
                className={styles.expandButton}
                onClick={toggle}
                aria-label={expanded ? 'Recolher' : 'Expandir'}
              >
                {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            )}
          </div>
        )}
      </div>

      {collapsible ? (
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          {body}
        </Collapse>
      ) : body}
    </section>
  );
};

export default ModuleCard;
